<template>
	<div data-tour-scope="setting-finance">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.subsetting.finance') }} </v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
						</v-toolbar>


						<v-data-table
							:headers="headers"
							class="elevation-0 cellanowrap"
							:hide-default-header="mobileCards"
							:class="{ mobile: isMobile, 'table-cards': mobileCards }"
							hide-default-footer
							disable-pagination
							disable-sort
							item-key="item._id"
							data-tour="table"
						>
							<template v-slot:body>
								<!-- telefono: ogni servizio diventa una card con interruttore e configurazione -->
								<tbody v-if="mobileCards" class="finance-cards">
									<tr>
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card>
												<template v-slot:title>
													<v-avatar size="24px" tile class="mr-2">
														<img :src="require('@/assets/images/fattureincloud_active.svg')" alt="Fatture in cloud" />
													</v-avatar>
													Fatture in cloud
												</template>
												<template v-slot:actions>
													<v-switch v-model="fattureInCloud.active" @change="cambiaStato(0, $event)" color="primary" class="mt-0 pt-0 mr-2" hide-details></v-switch>
													<v-btn small icon color="primary" data-tour="expand" :title="checkpresenza(0) ? 'Chiudi' : 'Configura'" @click="extension(0)">
														<v-icon>{{ checkpresenza(0) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
												</template>
												<fatture-in-cloud-panel
													v-if="checkpresenza(0)"
													:modello="fattureInCloud"
													:statusorders="statusorders"
													:corrispettivi="corrispettiviCard"
													:intestazione="false"
													data-tour="settings"
													@save="saveSetting(0)"
													@sync="updateSettingsFattInCloud()"
													@authorize="checkauthFattureincloud()"
													@check="openConnectionCheck('fattureInCloud')"
													@refresh-companies="switchFattureincloud()"
													@drop="updateDropCorrispettivo"
												/>
											</key-value-card>
										</td>
									</tr>
									<tr>
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card>
												<template v-slot:title>
													<v-avatar size="24px" tile class="mr-2">
														<img :src="require('@/assets/images/finanza/aruba.svg')" alt="Aruba" />
													</v-avatar>
													Aruba
												</template>
												<template v-slot:actions>
													<v-switch v-model="aruba.active" @change="cambiaStato(2, $event)" color="primary" class="mt-0 pt-0 mr-2" hide-details></v-switch>
													<v-btn small icon color="primary" :title="checkpresenza(2) ? 'Chiudi' : 'Configura'" @click="extension(2)">
														<v-icon>{{ checkpresenza(2) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
												</template>
												<aruba-panel v-if="checkpresenza(2)" :modello="aruba" :test="arubaTest" @save="saveSetting(2)" @test="testAruba()" />
											</key-value-card>
										</td>
									</tr>
									<tr v-for="s in serviziSemplici" :key="s.key">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card>
												<template v-slot:title>
													<v-avatar size="24px" tile class="mr-2">
														<img :src="s.logo" :alt="s.nome" />
													</v-avatar>
													{{ s.nome }}
												</template>
												<template v-slot:actions>
													<v-switch v-model="modello(s).active" @change="cambiaStato(s.indice, $event)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</template>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr class="as-list-row" :class="{ 'as-list-row--open': checkpresenza(0) }" @click="extension(0)">
										<td class="pr-0" style="width: 40px">
											<v-btn small icon data-tour="expand" :title="checkpresenza(0) ? 'Chiudi' : 'Configura'" @click.stop="extension(0)">
												<v-icon>{{ checkpresenza(0) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
											</v-btn>
										</td>
										<td>
											<v-avatar size="32px" tile>
												<img :src="require('@/assets/images/fattureincloud_active.svg')" alt="Fatture in cloud" />
											</v-avatar>
											Fatture in cloud
										</td>
										<td @click.stop>
											<v-switch v-model="fattureInCloud.active" @change="cambiaStato(0, $event)" color="primary" class="mt-0" hide-details></v-switch>
										</td>
									</tr>
									<tr v-if="checkpresenza(0)" class="as-expanded">
										<td :colspan="headers.length" class="py-3">
											<fatture-in-cloud-panel
												:modello="fattureInCloud"
												:statusorders="statusorders"
												:corrispettivi="corrispettiviCard"
												data-tour="settings"
												@save="saveSetting(0)"
												@sync="updateSettingsFattInCloud()"
												@authorize="checkauthFattureincloud()"
												@check="openConnectionCheck('fattureInCloud')"
												@refresh-companies="switchFattureincloud()"
												@drop="updateDropCorrispettivo"
											/>
										</td>
									</tr>
									<tr class="as-list-row" :class="{ 'as-list-row--open': checkpresenza(2) }" @click="extension(2)">
										<td class="pr-0" style="width: 40px">
											<v-btn small icon :title="checkpresenza(2) ? 'Chiudi' : 'Configura'" @click.stop="extension(2)">
												<v-icon>{{ checkpresenza(2) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
											</v-btn>
										</td>
										<td>
											<v-avatar size="32px" tile>
												<img :src="require('@/assets/images/finanza/aruba.svg')" alt="Aruba" />
											</v-avatar>
											Aruba
										</td>
										<td @click.stop>
											<v-switch v-model="aruba.active" @change="cambiaStato(2, $event)" color="primary" class="mt-0" hide-details></v-switch>
										</td>
									</tr>
									<tr v-if="checkpresenza(2)" class="as-expanded">
										<td :colspan="headers.length" class="py-3">
											<aruba-panel :modello="aruba" :test="arubaTest" @save="saveSetting(2)" @test="testAruba()" />
										</td>
									</tr>
									<tr v-for="s in serviziSemplici" :key="s.key">
										<td></td>
										<td>
											<v-avatar size="32px" tile>
												<img :src="s.logo" :alt="s.nome" />
											</v-avatar>
											{{ s.nome }}
										</td>
										<td>
											<v-switch v-model="modello(s).active" @change="cambiaStato(s.indice, $event)" color="primary" class="mt-0" hide-details></v-switch>
										</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<!-- un solo servizio di fatturazione attivo: prima di accenderne uno si avvisa chi verra' spento -->
		<v-dialog v-model="conferma.aperta" max-width="420" persistent>
			<v-card>
				<v-card-title class="text-h6">Cambiare servizio di fatturazione?</v-card-title>
				<v-card-text class="text-left">{{ conferma.testo }}</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="annullaCambioStato">Annulla</v-btn>
					<v-btn color="primary" depressed @click="confermaCambioStato">Conferma</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<TourOverlay :tour="tour"></TourOverlay>
		<marketplace-connection-check v-model="connectionCheck.open" :service="connectionCheck.service"></marketplace-connection-check>
	</div>
</template>
<style scoped>
/* lista compatta: la riga aperta si colora e sotto compare il riquadro di configurazione */
.as-list-row {
	cursor: pointer;
}
.as-list-row--open,
.as-list-row--open:hover {
	background: #f3f6fa !important;
}
.as-expanded,
.as-expanded:hover {
	background: transparent !important;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.finance-cards,
.finance-cards tr {
	display: block;
	width: 100%;
}
.finance-cards tr,
.finance-cards tr:hover {
	background: transparent !important;
}
.finance-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.finance-cards tr:first-child td {
	padding-top: 12px !important;
}
.finance-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.finance-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* righe trascinabili della descrizione corrispettivi */
.corrispettivo-line {
	gap: 4px;
	padding: 4px 8px;
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 4px;
	font-size: 14px;
}
.corrispettivo-line + .corrispettivo-line {
	margin-top: 6px;
}
.card-url {
	word-break: break-all;
}
</style>

<script>
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createFinanceTourSteps, stopFinanceTour } from './finance-tour';
import FattureInCloudPanel from './components/FattureInCloudPanel.vue';
import MarketplaceConnectionCheck from './components/MarketplaceConnectionCheck.vue';
import ArubaPanel from './components/ArubaPanel.vue';

// servizi di fatturazione: indice usato da saveSetting/extension -> oggetto in data e nome mostrato
const SERVIZI_FATTURAZIONE = {
	0: { key: 'fattureInCloud', nome: 'Fatture in Cloud' },
	1: { key: 'danea', nome: 'Danea' },
	2: { key: 'aruba', nome: 'Aruba' },
};
export default {
	name: 'Finance',
	setup() {
		return { tour: useTour(createFinanceTourSteps(), { onStop: stopFinanceTour }) };
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
	data() {
		return {
			loadingSync: false,
			// verifica connessione Fatture in Cloud: verifica il token salvato
			connectionCheck: { open: false, service: 'fattureInCloud' },
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// riquadri di configurazione aperti (indice del servizio)
			selected: [],
			headers: [{ text: '', sortable: false }, { text: 'Servizio', sortable: false }, { text: 'Status', sortable: false }],

			messages: {
				email: [],
				name: [],
				password: [],
			},

			isMobile: false,
			fattureInCloud: {
				active: '',
				setting: {
					clientId: '',
					clientSecret: '',
				},
				type: 'finance',
				service: 'fattureInCloud',
			},
			danea: {
				active: false,
				setting: {},
				type: 'finance',
				service: 'danea',
			},
			aruba: {
				active: false,
				setting: { username: '', password: '', ambiente: 'produzione', hasPassword: false },
				type: 'finance',
				service: 'aruba',
			},
			arubaTest: { loading: false, esito: null },
			// conferma di attivazione quando un altro servizio di fatturazione e' gia' acceso
			conferma: { aperta: false, testo: '', indice: null },
			// servizi con il solo interruttore: indice = argomento di saveSetting, key = oggetto in data
			serviziSemplici: [{ indice: 1, key: 'danea', nome: 'Danea', logo: require('@/assets/images/finanza/danea.png') }],
			statusorders: [],
		};
	},

	filters: {
		fixed: function (value) {
			if (!+value) return '';
			//  return  value = value.toFixed(2)
			return _.round(value, 2);
			//return  value
		},
	},

	async created() {
		this.setPreload(true);
		let promises = [];
		promises.push(this.fetchSettings());
		promises.push(this.fetchService(['fattureInCloud', 'danea', 'aruba']));
		await Promise.all(promises);
		const service_fi = _.find(this.getServices, { service: 'fattureInCloud' });
		const service_danea = _.find(this.getServices, { service: 'danea' });
		const service_aruba = _.find(this.getServices, { service: 'aruba' });

		if (service_fi) {
			this.fattureInCloud = service_fi;
			Object.assign(this.fattureInCloud, { type: 'fattureInCloud' });
		}
		if (service_danea) {
			this.danea = service_danea;
		}
		if (service_aruba) {
			this.aruba = service_aruba;
			this.aruba.setting = { username: '', ambiente: 'produzione', ...(service_aruba.setting || {}), password: '' };
		}
		if (!this.fattureInCloud?.setting?.associates) {
			this.fattureInCloud.setting.associates = {
				iva: [],
				payment: [],
			};
		}
		if (!this.fattureInCloud?.setting?.corrispettiviautomatici) {
			this.fattureInCloud.setting.corrispettiviautomatici = false;
			this.fattureInCloud.setting.corrispettiviautomaticistatus = '';
		}
		/*if (!this.fattureInCloud.setting?.trasportoiva) {
			this.fattureInCloud.setting.trasportoiva = '';
		}*/
		if (!this.fattureInCloud?.setting?.corrispettivo) {
			this.fattureInCloud.setting.corrispettivo = [
				{
					key: 'OrderID',
					active: true,
				},
				{
					key: 'created_at',
					active: false,
				},
				{
					key: 'Total',
					active: true,
				},
				{
					key: 'Platform',
					active: false,
				},
				{
					key: 'Site',
					active: false,
				},
				{
					key: 'Country',
					active: false,
				},
				{
					key: 'Name',
					active: false,
				},
			];
		}

		this.getSettings?.vat.forEach(el => {
			let found = this.fattureInCloud?.setting?.associates?.iva.find(i => {
				return i._id === el._id;
			});
			if (found) {
				//this.fattureInCloud.setting.associates.iva.push(found);
			} else {
				this.fattureInCloud?.setting?.associates?.iva.push({
					_id: el._id,
					name: el.vat,
					code: '',
				});
			}
		});
		let payments = await this.fetchPayments();

		payments.data.forEach(el => {
			let found = this.fattureInCloud?.setting?.associates?.payment.find(i => {
				return i._id === el._id;
			});
			if (found) {
				//this.fattureInCloud.setting.associates.iva.push(found);
			} else {
				this.fattureInCloud?.setting?.associates?.payment.push({
					_id: el._id,
					name: el.value,
					code: '',
				});
			}
		});

		const statusorders = await this.fetchStatusOrder();

		_.forEach(statusorders.data, el => {
			var textStatus = _.find(el.trans, { lang: this.getLanguage });
			//this.status.push({'text':textStatus.value,'value':textStatus.value})
			this.statusorders.push({ _id: el._id, value: textStatus.value });
		});

		this.setPreload(false);
	},

	components: {
		TourOverlay,
		FattureInCloudPanel,
		ArubaPanel,
		KeyValueCard,
		MarketplaceConnectionCheck,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// copia della lista come fa v-data-table con props.items: il riordino vero lo fa updateDropCorrispettivo
		corrispettiviCard() {
			return (this.fattureInCloud.setting.corrispettivo || []).slice();
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',
			getLanguage: 'profile/getLanguage',
			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getSettings: 'settings/getSetting',
			getDrawerFilter: 'settings/getDrawerFilter',
			getServices: 'services/getServices',
		}),
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			fetchService: 'services/getServiceFetch',
			fetchPayments: 'paymentmethods/fetchLists',
			destroyData: 'settings/destroyData',
			setSettings: 'settings/updateData',
			setService: 'services/updateData',
			fetchStatusOrder: 'statusorders/fetchLists',
		}),
		async updateDropCorrispettivo(dropResult) {
			this.oldValue = this.fattureInCloud.setting.corrispettivo[dropResult.moved.oldIndex];
			this.newValue = this.fattureInCloud.setting.corrispettivo[dropResult.moved.newIndex];

			this.fattureInCloud.setting.corrispettivo.splice(dropResult.moved.oldIndex, 1);
			this.fattureInCloud.setting.corrispettivo.splice(dropResult.moved.newIndex, 0, this.oldValue);

			//this.form.values[dropResult.moved.newIndex]=this.oldValue
			//this.form.values[dropResult.moved.oldIndex]=this.newValue
		},
		changeStatus(item) {
			var payload;
			switch (item) {
				case 0:
					payload = this.fattureInCloud;
					//this.preload = true;
					this.setPreload(true);
					break;
			}
			let url = 'services/update';
			axios
				.patch(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					//   console.log(data.data);
					this.setService(data.data);
					this.applicaDisattivati(data.disabled);
					this.setPreload(false);
					//this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});

			//console.log(item)
		},
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		saveSetting(item) {
			var payload;
			switch (item) {
				case 0:
					//Object.assign(this.fattureInCloud.associates,)
					payload = this.fattureInCloud;

					this.setPreload(true);
					break;
				case 1:
					payload = this.danea;
					this.setPreload(true);
					break;
				case 2:
					payload = this.aruba;
					this.setPreload(true);
					break;
			}

			let url = 'services/update';
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					//   console.log(data.data);
					this.setService(data.data);
					this.applicaDisattivati(data.disabled);
					// la password salvata non torna dal server: il campo si svuota e resta solo hasPassword
					if (item === 2 && data.data && data.data.setting) {
						this.aruba.setting.password = '';
						this.aruba.setting.hasPassword = !!data.data.setting.hasPassword;
					}

					this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});

			//console.log(`${this.getUrl}${url}`);
		},
		extension(item) {
			var prova = this.selected.includes(item);
			if (!prova) {
				this.selected.push(item);
			} else {
				var indice = this.selected.indexOf(item);
				this.selected.splice(indice, 1);
			}

			/*this.selected.push(item)

                    if (!this.getOrders[item].hide) {
                        this.getOrders[item].hide = true;
                    } else  {
                        this.getOrders[item].hide = false;
                    }*/
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},
		// interruttore di un servizio di fatturazione: se un altro e' acceso si chiede conferma,
		// perche' il backend lo spegnera' (ne resta attivo uno solo)
		cambiaStato(indice, attivo) {
			const altri = Object.keys(SERVIZI_FATTURAZIONE)
				.map(Number)
				.filter(i => i !== indice && this[SERVIZI_FATTURAZIONE[i].key].active === true)
				.map(i => SERVIZI_FATTURAZIONE[i].nome);
			if (attivo && altri.length > 0) {
				this.conferma = {
					aperta: true,
					indice,
					testo: `Attivando ${SERVIZI_FATTURAZIONE[indice].nome} verra' disattivato ${altri.join(' e ')}: puo' essere attivo un solo servizio di fatturazione alla volta.`,
				};
				return;
			}
			this.eseguiCambioStato(indice);
		},
		annullaCambioStato() {
			const indice = this.conferma.indice;
			this.conferma = { aperta: false, testo: '', indice: null };
			if (indice !== null) {
				this[SERVIZI_FATTURAZIONE[indice].key].active = false;
			}
		},
		confermaCambioStato() {
			const indice = this.conferma.indice;
			this.conferma = { aperta: false, testo: '', indice: null };
			this.eseguiCambioStato(indice);
		},
		eseguiCambioStato(indice) {
			// Fatture in Cloud salva solo lo stato (PATCH); gli altri salvano anche la configurazione
			if (indice === 0) {
				this.changeStatus(0);
			} else {
				this.saveSetting(indice);
			}
		},
		// servizi spenti dal backend all'attivazione di un altro
		applicaDisattivati(disattivati) {
			(disattivati || []).forEach(service => {
				const servizio = Object.values(SERVIZI_FATTURAZIONE).find(s => s.key === service);
				if (servizio) {
					this[servizio.key].active = false;
				}
			});
		},
		openConnectionCheck(service) {
			this.connectionCheck.service = service;
			this.connectionCheck.open = true;
		},
		testAruba() {
			this.arubaTest = { loading: true, esito: null };
			axios
				.post(`${this.getUrl}aruba/test`, { setting: this.aruba.setting }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.arubaTest = { loading: false, esito: { success: true, data: data.data } };
				})
				.catch(err => {
					const message = (err.response && err.response.data && err.response.data.message) || 'Impossibile verificare la connessione';
					this.arubaTest = { loading: false, esito: { success: false, message } };
					if (err.response && err.response.status === 401) {
						this.setLogout();
						this.$router.push('/login');
					}
				});
		},
		// oggetto in data del servizio (danea, aruba): created() lo sostituisce, quindi va letto ogni volta
		modello(servizio) {
			return this[servizio.key];
		},
		// "Aggiorna l'elenco delle aziende": il backend rilegge le aziende da Fatture in Cloud e le salva.
		// Prima la risposta veniva scartata (un `return` in testa al then) e l'elenco non cambiava mai.
		switchFattureincloud() {
			let payload = this.fattureInCloud;
			let url = 'fattureincloud/switchaccount';
			this.setPreload(true);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.setPreload(false);
					if (!data || data.success === false || !data.data) {
						this.snackbar.color = 'error';
						this.snackbar.text = 'Fatture in Cloud non configurato: impossibile aggiornare le aziende';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						return;
					}
					this.success = true;

					this.setService(data.data);

					if (data?.data) {
						this.fattureInCloud = data.data;
					}
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					this.setPreload(false);
					if (err.response) {
						this.snackbar.color = 'error';
						this.snackbar.text = err.response.data.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		checkauthFattureincloud() {
			if (!this.fattureInCloud?.setting?.clientId || !this.fattureInCloud?.setting?.clientSecret) {
				this.snackbar.color = 'error';
				this.snackbar.text = 'clientId ID e clientSecret obbligatori';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				return;
			}
			let url = 'fattureincloud/oauth';
			axios
				.get(`${this.getUrl}${url}`, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.preload = false;
					window.location.href = data.data;
					/*this.snackbar.color = 'success';
            this.snackbar.text = 'Operazione effettuata con  successo';
            this.snackbar.snackbar = true;
            this.snackbar.mode = 'multi-line';
            this.snackbar.timeout = 5000;*/
				})
				.catch(err => {
					if (err.response) {
						this.snackbar.color = 'error';
						this.snackbar.text = err.response.data.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		updateSettingsFattInCloud() {
			this.setPreload(true);
			var payload = {};

			let url = 'fattureincloud/sincronizza';
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					//   this.dialog = false;
					//   this.success = true;
					//   console.log(data.data);
					this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}
						this.setPreload(false);
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.loadingSync = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});

			//console.log(`${this.getUrl}${url}`);
		},
	},
};
</script>

<style></style>
